import { ApolloLink, Observable } from 'apollo-link';

function subscribeToEcho(echoClient, channelName, observer) {
    var channel = echoClient.private(channelName.replace(/^private\-/, ''));
    channel.listen(".lighthouse-subscription", function (result) { var _a; return observer.next(((_a = result.data) === null || _a === void 0 ? void 0 : _a.data) || result.data); });
}
function unsubscribe(echoClient, getChannelName) {
    var channelName = getChannelName();
    if (channelName) {
        echoClient.leave(channelName);
    }
}
function createSubscriptionHandler(echoClient, operation, observer, setChannelName) {
    return function (data) {
        var _a, _b, _c, _d, _e, _f, _g;
        var operationDefinition = operation.query.definitions.find(function (definitionNode) { return definitionNode.kind === "OperationDefinition"; });
        var fieldNode = operationDefinition.selectionSet.selections.find(function (definitionNode) { return definitionNode.kind === "Field"; });
        var subscriptionName = fieldNode.name.value;
        var lighthouseVersion = (_b = (_a = data === null || data === void 0 ? void 0 : data.extensions) === null || _a === void 0 ? void 0 : _a.lighthouse_subscriptions) === null || _b === void 0 ? void 0 : _b.version;
        var channelName = lighthouseVersion == 2 ? (_d = (_c = data === null || data === void 0 ? void 0 : data.extensions) === null || _c === void 0 ? void 0 : _c.lighthouse_subscriptions) === null || _d === void 0 ? void 0 : _d.channel : (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.extensions) === null || _e === void 0 ? void 0 : _e.lighthouse_subscriptions) === null || _f === void 0 ? void 0 : _f.channels) === null || _g === void 0 ? void 0 : _g[subscriptionName];
        if (channelName) {
            setChannelName(channelName);
            subscribeToEcho(echoClient, channelName, observer);
        }
        else {
            observer.next(data);
            observer.complete();
        }
    };
}
function createRequestHandler(echoClient) {
    return function (operation, forward) {
        var channelName;
        return new Observable(function (observer) {
            forward(operation).subscribe(createSubscriptionHandler(echoClient, operation, observer, function (name) { return channelName = name; }));
            return function () { return unsubscribe(echoClient, function () { return channelName; }); };
        });
    };
}
function createLighthouseSubscriptionLink(echoClient) {
    return new ApolloLink(createRequestHandler(echoClient));
}

export { createLighthouseSubscriptionLink };
